export default __webpack_public_path__ + "static/media/icon-role-Data-Scientist.0145a497.svg";